import { RiErrorWarningLine } from "@remixicon/react";
import { Button } from "@earth-note/ui";

interface ErrorStateProps {
  message: string;
  onRetry?: () => void;
}

export function ErrorState({ message, onRetry }: ErrorStateProps) {
  return (
    <div className="flex h-full flex-col items-center justify-center p-6 text-center">
      <div className="mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-red-100">
        <RiErrorWarningLine className="h-6 w-6 text-red-600" />
      </div>
      <h3 className="text-label-md mb-2 font-medium text-text-strong-950">Something went wrong</h3>
      <p className="text-paragraph-sm mb-4 text-text-sub-600">{message}</p>
      {onRetry && (
        <Button.Root onClick={onRetry} size="small">
          Try Again
        </Button.Root>
      )}
    </div>
  );
}
